'use strict';
; (function () {
    angular.module("EMR.AddOrEditMessageDefaultTemplateCustomizationPopupModule", []);

    var AddOrEditMessageDefaultTemplateCustPopupModuleRoutes = [
        {
            "name": "AddOrEditMessageDefaultTemplateCustomization",
            "RoutingNumber": 2391,
            templateUrl: "<div emr-add-or-edit-message-default-template-customization-popup></div>",
            files: [
                "AngularScripts/AddOrEditMessageDefaultTemplateCustomization/Services/AddOrEditMessageDefaultTemplateCustomizationPopupService.js",
                "AngularScripts/AddOrEditMessageDefaultTemplateCustomization/Directives/AddOrEditMessageDefaultTemplateCustomizationPopupDirective.js",
            ]
        },

    ]

    angular.module('EMR.AddOrEditMessageDefaultTemplateCustomizationPopupModule')
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(AddOrEditMessageDefaultTemplateCustPopupModuleRoutes, $stateProvider);
            }]);
})();

